import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { requiredStringSchema } from '@/js/libs/form';

import { PIN_LENGTH } from './constants.ts';

export const useVerifyPinFormSchema = () => {
  const [t] = useTranslation(['admin']);

  return useMemo(
    () =>
      z.object({
        pin: requiredStringSchema((schema) => schema.length(PIN_LENGTH, t('admin:TEMPORARY_ACCESS_PIN_INVALID_LENGTH'))),
      }),
    [t],
  );
};

type Schema = ReturnType<typeof useVerifyPinFormSchema>;
export type FormValues = z.input<Schema>;
export type SubmitValues = z.output<Schema>;
